export default __webpack_public_path__ + "static/10-5e0b1752b03e36da96caeb442520262e.jpg";